import { Box, Button, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../components/common/BackButton';
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { loadPortfolioTracking } from '../../store/actions/portfolioTracking';
import TrackStepList from '../../components/trackPortfolio/TrackStepList';

const PortfolioTrackingPage: React.FC = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const tracking = useAppSelector(state => state.portfolioTracking.portfolio);
    const dispatch = useAppDispatch();

    const idAsNumber = parseInt(id as string);
    if (id === undefined) {
        navigate(-1);
    }

    useEffect(() => {
        dispatch(loadPortfolioTracking(id as string));
    }, [dispatch, idAsNumber]);

    const onGoToDashboard = () => {
        navigate(AUTHENTICATED_ROUTES.HOMEPAGE_ROUTE);
    }

    return <Box display={"flex"} margin={"0"} justifyContent={"center"} overflow={"auto"}>
        <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1400px"} gap={"21px"}>
            <Box display={"flex"} alignItems={"center"} width={"100%"} gap={"16px"}>
                <BackButton to={AUTHENTICATED_ROUTES.PORTFOLIOS_ROUTE} />
                <Typography variant='h3'>{t('TrackingPortfolioPageTitle')}</Typography>
            </Box>
            {tracking === undefined ?
                <CircularProgress />
                :
                <TrackStepList tracking={tracking}/>
            }
            <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} paddingBottom={"20px"}>
                <Button variant="contained" onClick={onGoToDashboard}>{t('TrackingPortfolioGoToDashboard')}</Button>
            </Box>
        </Box>
    </Box>
}

export default PortfolioTrackingPage;